module.exports = __webpack_public_path__ + "assets/img/ico-1.343e07d0.webp";